// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ud-2";
export var chatLink = "_ud-0";
export var chatText = "_ud-1";